import { ChangeDetectionStrategy, Component, computed, input, OnInit, signal } from '@angular/core';
import { NgClass } from '@angular/common';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { NgbCollapse } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'mwe-collapse',
  templateUrl: './collapse.component.html',
  imports: [NgClass, TranslateDirective, NgbCollapse, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CollapseComponent implements OnInit {
  collapseId = input<string>();
  titleMessageKey = input<string>();
  subtitleMessageKey = input<string>();
  iconClass = input<string>();
  initialState = input<'expanded' | 'collapsed'>('collapsed');
  showBoxStyle = input<boolean>(true);
  headerTranslateParams = input<any>();
  outerClass = input<string>('mb-3 mb-lg-4');
  headerTheme = input<
    'primary' | 'secondary' | 'secondary-light' | 'tertiary' | 'success' | 'info' | 'warning' | 'danger' | 'light' | 'dark' | ''
  >('');
  headerMarginPadding = input<string>('py-4');
  isCollapseHeaderVisible = input<boolean>(true);
  contentClass = input<string>('py-4');

  //TODO: delete deprecated variables later
  headerClass = input<string>('mb-0');
  addMarginPadding = input<boolean>(true);
  // shitty solution but sometimes .expander-item overwrites some simple styles in the content-child-components
  noExpanderItemClass = input<boolean>(false);

  isCollapsed = signal<boolean>(true);
  headerBackgroundColor = computed<string>(() => `bg-${this.headerTheme()}`);
  headerTextClass = computed<string>(() => (this.headerTheme() ? 'text-white' : undefined));
  chevronButton = computed<string>(() => (this.headerTheme() ? 'btn-ghost' : 'btn-primary--dark-blue'));
  ngOnInit(): void {
    this.isCollapsed.set(this.initialState() === 'collapsed');
  }
}
